import React from 'react';
import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { StructureService } from '../../../../services/structure_service';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { DateneingabeVSMEAuswahl } from '../../DateneingabeVSMEAuswahl';
import { HinweiseElementVsme } from '../../assistent/items/custom/HinweiseElementVsme';

export function getVsmePatEntities() {
    const group = 'vsme_pat';
    return [
        { gliederung: '3.', gliederung2: 'II.', collapsible: group, name: 'PAT-Modul' },
        { gliederung: '3.1', key: IDs.ENT_VSME_N1, group, singleItem: true },
        { gliederung: '3.2', key: IDs.ENT_VSME_N2, group, singleItem: true },
        { gliederung: '3.3', key: IDs.ENT_VSME_N3, group, singleItem: true  },
        { gliederung: '3.4', key: IDs.ENT_VSME_N4, group, singleItem: true  },
        { gliederung: '3.5', key: IDs.ENT_VSME_N5, group, singleItem: true  }
    ];
}

export function getAssistentConfigVsmePatItems(standort: any, data: any, jahr: number, triggerService: TriggerService, structureService: StructureService): Array<AssistentItem> {
    const ents = getVsmePatEntities();
    const category = 'vsme_pat';
    const items: Array<AssistentItem> = ents.map((e: any) => {
        if (e.collapsible && !e.key) {
            return {
                collapsible: e.collapsible,
                group: e.group,
                gliederung: e.gliederung,
                gliederung2: e.gliederung2,
                name: e.name,
                style: { backgroundColor: '#616468', color: 'white' },
                type: 'CustomGroupElement',
                customElements: [
                    <div style={{ marginBottom: 10 }}>
                        <HinweiseElementVsme
                            stlye={{ maxWidth: 743, margin: 0 }}
                            textKey={`hinweis_vsme_pat`}
                            data={data}
                        />
                    </div>,
                    <DateneingabeVSMEAuswahl
                        key={`vsme_auswahl_${category}`}
                        category={category}
                        data={data}
                        standortSelected={standort}
                        jahrFix={jahr}
                        hideJahr={true}
                        showHelpIcon={true}
                    />
                ]
            };
        }
        const structure: any = structureService.getStructureByKey(IDs.MOD_ETOOL, e.key) || {};
        return {
            collapsible: e.collapsible,
            group: e.group,
            gliederung: e.gliederung,
            gliederung2: e.gliederung2,
            name: structure.TITEL,
            dataName: structure.TITEL,
            description: 'Dies ist das Formular zur Eingabe der VSME-Daten.',
            type: 'EntityForm',
            addLabel: 'Neuen Datensatz erfassen',
            entity: e.key,
            configFlag: 'inputVsmePat',
            singleItem: e.singleItem,
            customOnSaveDone: (ent: string, dataItem: any) => {
                triggerService.fire('reload', ent);
            }
        }
    });
    return items;
}
